module.exports = __webpack_public_path__ + "img/bus_icon.41517bd7.svg";